module.exports = __webpack_public_path__ + "img/hra.a94e7394.jpg";